import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { sixYardAxios } from '../../sixYardAxios';
import { connect } from 'react-redux';
import ScrollToTop from '../hoc/layout/scrollToTop/scrollToTop';
import Layout from '../hoc/layout/layout';
import Home from '../../pages/home/home';
import WhatsNew from '../../pages/whatsNew/whatsNew';
import AboutUs from '../../pages/aboutUs/aboutUs';
import Academy from '../../pages/academy/academy';
import Camps from '../../pages/camps/camps';
import Activities from '../../pages/activities/activities';
import Tournaments from '../../pages/tournaments/tournaments';
import TournamentDetails from "../../components/tournaments/details/details";
import ContactUs from '../../pages/contactUs/contactUs';
import Franchise from '../../pages/franchise/franchise';
import Login from '../../pages/login/login';
import SignUp from '../../pages/signUp/signUp';
import Profile from '../../pages/profile/profile';
import ForgotPassword from '../../pages/forgotPassword/forgotPassword';
import FieldBookingForm from '../../pages/fieldBooking/fieldBooking';
import TermsAndConditions from '../../pages/termsAndConditions/termsAndConditions';
import PrivacyPolicy from '../../pages/privacyPolicy/privacyPolicy';
import NotFound from '../../pages/notFound/notFound';
import FontComparison from '../FontComparison';

const Main = (props) => {
    const [menuItems, setMenuItems] = useState([]);
    const [heroSection, setHeroSection] = useState("");
    const [promotions, setPromotions] = useState([]);
    const [pricingPackages, setPricingPackages] = useState([]);
    const [featuredActivities, setFeaturedActivities] = useState([]);
    const [app, setApp] = useState({});
    const [pageSections, setPageSections] = useState([]);
    const [features, setFeatures] = useState([]);
    const [socialLinks, setSocialLinks] = useState([]);
    const [quickLinks, setQuickLinks] = useState([]);
    const [contactInfo, setContactInfo] = useState({});
    const [bookNowAndChatBoxClicked, setBookNowAndChatBoxClicked] = useState(false);
    const [showCampRegistrationForm, setShowCampRegistrationForm] = useState(false);
    const [camp, setCamp] = useState("");

    useEffect(() => {
        fetchHome();
        fetchUserLoyalityPoints();
    }, [props.selectedLanguage]);
    
    const fetchUserLoyalityPoints = () => {
            sixYardAxios.get('/profile/loyalty-points')
        };
    const fetchHome = () => {
        sixYardAxios.get("/home").then(res => {
            setMenuItems(res.data.data.menu_items);
            setHeroSection(res.data.data.hero_section);
            setPromotions(res.data.data.promotions);
            setPricingPackages(res.data.data.pricing_packages);
            setFeaturedActivities(res.data.data.featured_activities);
            setApp(res.data.data.app);
            setPageSections(res.data.data.page_sections);
            setFeatures(res.data.data.features);
            setSocialLinks(res.data.data.social_links);
            setQuickLinks(res.data.data.quick_links);
            setContactInfo(res.data.data.contact_info);
        }).catch(e => {});
    };

    return (
        <Router>
            <ScrollToTop />
            <Routes>
                <Route path="/" element={<Layout menuItems={menuItems} pageSections={pageSections}
                    socialLinks={socialLinks} quickLinks={quickLinks} contactInfo={contactInfo} 
                    bookNowAndChatBoxClicked={bookNowAndChatBoxClicked} camp={camp} setCamp={setCamp}
                    setBookNowAndChatBoxClicked={setBookNowAndChatBoxClicked} showCampRegistrationForm={showCampRegistrationForm}
                    setShowCampRegistrationForm={setShowCampRegistrationForm}/>}>
                    <Route index element={<Home heroSection={heroSection} promotions={promotions}
                        pricingPackages={pricingPackages} featuredActivities={featuredActivities} app={app}
                        pageSections={pageSections} features={features} />} />
                    <Route path="/whats-new" element={<WhatsNew />} />
                    <Route path="/about-us" element={<AboutUs />} />
                    <Route path="/academy" element={<Academy />} />
                    <Route path="/camps/:slug" element={<Camps setBookNowAndChatBoxClicked={setBookNowAndChatBoxClicked}
                    setShowCampRegistrationForm={setShowCampRegistrationForm} setCamp={setCamp}/>} />
                    <Route path="/activities/:slug" element={<Activities />} />
                    <Route path="/tournaments" element={<Tournaments />} />
                    <Route path="/tournaments/:id" element={<TournamentDetails />} />
                    <Route path="/contact-us" element={<ContactUs />} />
                    <Route path="/franchise" element={<Franchise />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<SignUp />} />
                    <Route path="/profile/:slug" element={<Profile />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/field-booking" element={<FieldBookingForm />} />
                    <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="/font-comparison" element={<FontComparison />} />
                    {/* Other routes */}
                    <Route path="/not-found" element={<NotFound />} />
                    <Route path="*" element={<NotFound />} />
                </Route>
            </Routes>
        </Router>
    )
}
const mapStateToProps = state => ({
    selectedLanguage: state.home.selected_language
});
export default connect(mapStateToProps)(Main);